export interface GetMyOrganizationInput {
  withAdmins?: boolean;
  withServiceUsers?: boolean;
  withInvites?: boolean;
  withOrganizationFoundations?: boolean;
  withOrganizationCommitteeFoundations?: boolean;
}
